<!-- Modal content -->
@if (fulfillmentModel) {
  <div class="modal-content">
    <div class="modal-header" [ngStyle]="{
            'justify-content': 'right',
            height: '40px',
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            'border-bottom':
          (Merchant$ | async)?.webapp_settings?.menu_border_width +
          'px solid ' +
          (Merchant$ | async)?.webapp_settings?.menu_border_color,
      }"
    >
      <a (click)="close()" id="btnnotification" class="close-icon">
        <i [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
                  }" class="zmdi zmdi-close zmdi-hc-fw"></i>
        </a>
        </div>
        <!-- istoodle flag used for hide table selection when user select pay with toodle option (Deeplink check ) -->
        <div class="modal-body">
      @if (isSelectedLocation) {
      <p [ngStyle]="{
                  color: (Merchant$ | async)?.webapp_settings
                    ?.menu_font_color_allpage,
                }" id="textcontent">
        Your last selected location is shown below. You can update it if you
        wish, or proceed with the same location.
      </p>
      } @else {
      <p [ngStyle]="{
                  color: (Merchant$ | async)?.webapp_settings
                    ?.menu_font_color_allpage,
                }" id="textcontent">
        {{ fulfillmentModel.dynamicTextMessage }}
        </p>
        }
        <!-- 2 - Onlinewebapp -->
        <!-- 3 - scanpromotionwebapp -->
      @if (
      (Merchant$ | async)?.webapp_settings?.is_scan_webapp == "2" ||
      (Merchant$ | async)?.webapp_settings?.is_scan_webapp == "3"
      ) {
      <div class="mb-2 custom-check">
          @if ((Merchant$ | async)?.webapp_settings?.is_collect == "1") {
          <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="collect" [ngStyle]="{
                                backgroundColor: (Merchant$ | async)?.webapp_settings
                                  ?.menu_color,
                                'border-color': (Merchant$ | async)?.webapp_settings
                    ?.menu_border_color,
                }"
                [ngModel]="fulfillmentModel.orderType"
                (change)="valueChanges($event)"
                value="collect"
              />
              <label class="form-check-label" for="collect">Collect</label>
            </div>
          }
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" id="deliver" [ngStyle]="{
                            backgroundColor: (Merchant$ | async)?.webapp_settings
                              ?.menu_color,
                            'border-color': (Merchant$ | async)?.webapp_settings
                  ?.menu_border_color,
              }"
              (change)="valueChanges($event)"
              [ngModel]="fulfillmentModel.orderType"
              value="deliver"
            />
            <label class="form-check-label" id="deliver" for="deliver"
              >Deliver</label
            >
          </div>
        </div>
      }
      <div class="col" style="width: 100%">
        <div class="form-group">
          <ng-select [items]="fulfillmentModel.tableOptions" class="ngselect2-modal" bindLabel="name"
            [(ngModel)]="fulfillmentModel.selectedTable"
            (ngModelChange)="
              LocationChanged(fulfillmentModel.selectedTable, false)
            "
            placeholder="Type or select"
            class="ngselect2-modal"
          >
          </ng-select>
        </div>
      </div>

      <!-- isroom flag used for display rooms listing instead of tables-->
      @if (fulfillmentModel.isroom) {
      <div class="col" style="width: 100%">
        <div class="form-group">
            <ng-select [items]="fulfillmentModel.roomOptions" bindLabel="name" [(ngModel)]="fulfillmentModel.selectedRoom"
              placeholder=" Start typing & select room " class="ngselect2-modal">
            </ng-select>
            </div>
            </div>
      }
      @if (
      isDelivery ||
      (Merchant$ | async)?.webapp_settings?.is_scan_webapp == "4"
      ) {
      <div class="col">
        <div class="form-group" style="width: 100%">
            <ng-select bindLabel="name" [items]="Addresses" [(ngModel)]="fulfillmentModel.selectedaddress"
              placeholder="Select address" class="ngselect2-modal">
              <ng-template ng-option-tmp let-item="item">
                <div class="address-option">
                  <div class="address-row">
                    <div class="address-name">{{ item.name }}</div>
                    <div class="button-container">
                      <button class="link-button" (click)="editAddress(item)">
                        Edit
                      </button>
                      <button class="link-button" (click)="deleteAddress(item)">
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            </div>
          <a (click)="OpenMap()" class="text-default" style="cursor: pointer" target="_blank">Click here to add new address</a>
          </div>
      } @else if (
      isServe || (Merchant$ | async)?.webapp_settings?.is_scan_webapp == "0"
      ) {
      <!-- @if(isServeItFees){ -->
        @if (IsAddressVisible) {
        @if (Addresses?.length > 0) {
        <div class="col">
          <div class="form-group" style="width: 100%">
                <ng-select bindLabel="name" [items]="Addresses" [(ngModel)]="fulfillmentModel.selectedaddress"
                  placeholder="Select address" class="ngselect2-modal">
                  <ng-template ng-option-tmp let-item="item">
                    <div class="address-option">
                      <div class="address-row">
                        <div class="address-name">{{ item.name }}</div>
                        <div class="button-container">
                          <button class="link-button" (click)="editAddress(item)">
                            Edit
                          </button>
                          <button class="link-button" (click)="deleteAddress(item)">
                            Delete
                          </button>
                          </div>
                          </div>
                          </div>
                          </ng-template>
                          </ng-select>
                          </div>
              <a (click)="OpenMap()" class="text-default" style="cursor: pointer" target="_blank">Click here to add new address</a>
              </div>
          }
          }
          <!-- } -->
          }
          <!-- <div class="col">
      <div class="form-group" style="width: 100%">
        <textarea #spacialinstruction [hidden]="fulfillmentModel.inputbox"
          [(ngModel)]="fulfillmentModel.specialInstructions" placeholder="notes" style="width: 100%"
          value=""></textarea>
      </div>
    </div> -->
      <div class="modal-footer" [ngStyle]="{ display: 'block' }">
        <div class="d-grid">
          <button class="btn btn-orange-light-theme btn-lg font-size-15 mt-2" [ngStyle]="{
                        color: (Merchant$ | async)?.webapp_settings
                          ?.menu_font_color_homepgae,
                        backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                        border:
                (Merchant$ | async)?.webapp_settings?.menu_border_width +
                'px solid ' +
                (Merchant$ | async)?.webapp_settings?.menu_border_color,
            }"
            (click)="LocationSelectedClick(fulfillmentModel)"
          >
            OK
          </button>
          <!-- <button
        [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :(Merchant$ | async)?.webapp_settings?.menu_border_width +
'px solid ' + (Merchant$ | async)?.webapp_settings?.menu_border_color}"
        (click)="close();">Cancel</button> -->
        </div>
        </div>
        </div>
        <!-- without inputbox -->
        </div>
}
